module.exports = __webpack_public_path__ + "res/fontawesome-webfont.eot?674f50d287a8c48dc19ba404d20fe713";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/fontawesome-webfont.eot
// module id = 11
// module chunks = 0